import React from "react";
import { FormattedMessage } from "react-intl";

import { getRetainersQuantityFromCourseOptionTag, isAdditionalAlignersCourse, isChildrenCourse, isPowerCapCourse, isRetainersCourse } from "~/common/courses";
import { LabelledValue } from "~/components/ui/labelled-value";
import type { TPatient } from "~/types/patient";
import type { TPrescription } from "~/types/prescription";

import { PatientCardCanines } from "./patient-card-canines";
import { PatientCardCloseAllGaps } from "./patient-card-close-all-gaps";
import { PatientCardElastics } from "./patient-card-elastics";
import { PatientCardIncisors } from "./patient-card-incisors";
import { PatientCardMolars } from "./patient-card-molars";
import { PatientCardTeethItems } from "./patient-card-teeth-items";
import { PatientCardTreatArches } from "./patient-card-treat-arches";

export function PatientCardRecipe({
  course_id,
  course_option_tag,
  prescription,
}: {
  course_id: TPatient["course"]["course_id"];
  course_option_tag: TPatient["course"]["course_option_tag"];
  prescription: TPrescription;
}) {
  return (
    <div>
      {isAdditionalAlignersCourse(course_id) ? null : <PatientCardTreatArches course_id={course_id} prescription={prescription} />}

      {isRetainersCourse(course_id) ? (
        <div>
          <LabelledValue label={<FormattedMessage id="RETAINERS_QUANTITY" />}>{getRetainersQuantityFromCourseOptionTag(course_option_tag)}</LabelledValue>
        </div>
      ) : null}

      {isRetainersCourse(course_id) || isAdditionalAlignersCourse(course_id) || isPowerCapCourse(course_id) ? null : (
        <>
          <PatientCardIncisors course_id={course_id} prescription={prescription} />

          {isChildrenCourse(course_id) ? null : <PatientCardCanines prescription={prescription} />}

          <PatientCardMolars course_id={course_id} prescription={prescription} />

          {isChildrenCourse(course_id) ? <PatientCardTeethItems label="EXTRA_TEETHING" defaultValue={prescription.teething} key={`EXTRA_TEETHING:${prescription.teething.join(",")}`} /> : null}

          {isChildrenCourse(course_id) ? null : (
            <>
              <PatientCardCloseAllGaps prescription={prescription} />
              <PatientCardElastics prescription={prescription} />

              <PatientCardTeethItems key={`EXTRA_NOMOVE:${prescription.dont_move.join(",")}`} label="EXTRA_NOMOVE" defaultValue={prescription.dont_move} />

              <PatientCardTeethItems key={`EXTRA_NOLOCK:${prescription.avoid_locks.join(",")}`} label="EXTRA_NOLOCK" defaultValue={prescription.avoid_locks} />

              <PatientCardTeethItems key={`EXTRA_EXTRACT:${prescription.extractions.join(",")}`} label="EXTRA_EXTRACT" defaultValue={prescription.extractions} />
            </>
          )}
        </>
      )}

      <LabelledValue label={<FormattedMessage id={isPowerCapCourse(course_id) ? "pat.power_cap.comment" : "EXTRA_COMMENTS"} />}>
        <span className="tw-whitespace-pre-wrap">{prescription.comment || <FormattedMessage id="None" />}</span>
      </LabelledValue>
    </div>
  );
}
